import React, { useState, useEffect } from 'react';
import { Button, Tag } from 'antd-mobile';
import { StarOutline, PlayOutline, ClockCircleOutline, UserOutline } from 'antd-mobile-icons';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import TextLightScroll from '../../components/texts/TextLightScroll';

const OnlineCourseList = () => {
  const navigate = useNavigate();

  const courses = [
    {
      id: 1,
      title: '量化交易入门与实战',
      description: '从零开始学习量化交易，掌握Python编程、数据分析、策略开发等核心技能',
      instructor: '张教授',
      duration: '8小时',
      level: '初级',
      rating: 4.8,
      students: 1250,
      price: 299,
      thumbnail: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=300&h=200&fit=crop',
      tags: ['Python', '金融', '数据分析']
    },
    {
      id: 2,
      title: 'AI机器学习算法详解',
      description: '深入理解机器学习核心算法，包括监督学习、无监督学习和强化学习',
      instructor: '李博士',
      duration: '12小时',
      level: '中级',
      rating: 4.9,
      students: 890,
      price: 399,
      thumbnail: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=300&h=200&fit=crop',
      tags: ['AI', '算法', '深度学习']
    },
    {
      id: 3,
      title: 'React前端开发实战',
      description: '全面掌握React生态系统，从基础组件到高级状态管理',
      instructor: '王工程师',
      duration: '10小时',
      level: '中级',
      rating: 4.7,
      students: 2100,
      price: 259,
      thumbnail: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=300&h=200&fit=crop',
      tags: ['React', '前端', 'JavaScript']
    },
    {
      id: 4,
      title: 'Python数据科学基础',
      description: '使用Python进行数据分析、可视化和机器学习入门',
      instructor: '陈分析师',
      duration: '6小时',
      level: '初级',
      rating: 4.6,
      students: 1800,
      price: 199,
      thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=300&h=200&fit=crop',
      tags: ['Python', '数据分析', '可视化']
    }
  ];

  const handleCourseClick = (courseId: number) => {
    navigate(`/learn/course/${courseId}`);
  };

  return (
    <StyledWrapper>
      <div className="course-list-container">
        <div className="header">
          <TextLightScroll text="在线课程" />
          <p>探索丰富的在线学习资源，提升你的技能</p>
        </div>

        <div className="filter-section">
          <div className="filter-tags">
            <Tag color="primary">全部</Tag>
            <Tag>编程</Tag>
            <Tag>AI/ML</Tag>
            <Tag>金融</Tag>
            <Tag>前端</Tag>
            <Tag>数据科学</Tag>
          </div>
        </div>

        <div className="courses-grid">
          {courses.map((course) => (
            <div key={course.id} className="course-card" onClick={() => handleCourseClick(course.id)}>
              <div className="course-thumbnail">
                <img src={course.thumbnail} alt={course.title} />
                <div className="course-overlay">
                  <div className="play-button">
                    <PlayOutline />
                  </div>
                  <div className="level-badge">{course.level}</div>
                </div>
              </div>
              <div className="course-content">
                <div className="course-header">
                  <h3>{course.title}</h3>
                  <div className="rating">
                    <StarOutline />
                    <span>{course.rating}</span>
                  </div>
                </div>
                <p className="description">{course.description}</p>
                <div className="course-meta">
                  <div className="meta-item">
                    <ClockCircleOutline />
                    <span>{course.duration}</span>
                  </div>
                  <div className="meta-item">
                    <UserOutline />
                    <span>{course.students}人</span>
                  </div>
                </div>
                <div className="course-tags">
                  {course.tags.map((tag, index) => (
                    <span key={index} className="tag">{tag}</span>
                  ))}
                </div>
                <div className="course-footer">
                  <span className="instructor">讲师: {course.instructor}</span>
                  <span className="price">{course.price}</span>
                </div>
                <button
                  className="learn-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCourseClick(course.id);
                  }}
                >
                  立即学习
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .course-list-container {
    padding: 40px 24px;
    max-width: 1200px;
    margin: 0 auto;
    color: #1f2937;
  }

  .header {
    text-align: center;
    margin-bottom: 40px;
    position: relative;
    
    p {
      font-size: 1.2rem;
      opacity: 0.9;
      margin: 0;
      padding-top: 80px;
    }
  }

  .filter-section {
    margin-bottom: 40px;
    
    .filter-tags {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  .courses-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 24px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  .course-card {
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    
    &:hover {
      transform: translateY(-8px) scale(1.02);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    }
  }

  .course-thumbnail {
    position: relative;
    height: 200px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
    
    &:hover img {
      transform: scale(1.1);
    }
  }

  .course-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.7) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.3s ease;
    
    .play-button {
      background: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1f2937;
      font-size: 24px;
      transform: scale(0.8);
      transition: all 0.3s ease;
    }
    
    .level-badge {
      position: absolute;
      top: 16px;
      right: 16px;
      background: rgba(76, 175, 80, 0.9);
      color: white;
      padding: 6px 12px;
      border-radius: 12px;
      font-size: 0.8rem;
      font-weight: 600;
      backdrop-filter: blur(10px);
    }
  }

  .course-card:hover .course-overlay {
    opacity: 1;
    
    .play-button {
      transform: scale(1);
    }
  }

  .course-content {
    padding: 24px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
  }

  .course-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
    
    h3 {
      font-size: 1.2rem;
      font-weight: 700;
      margin: 0;
      color: #1f2937;
      flex: 1;
      line-height: 1.4;
    }
    
    .rating {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #f59e0b;
      font-size: 0.9rem;
      font-weight: 600;
      margin-left: 12px;
    }
  }

  .description {
    font-size: 0.9rem;
    color: #6b7280;
    margin: 12px 0 16px 0;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .course-meta {
    display: flex;
    gap: 16px;
    margin: 16px 0;
    
    .meta-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 0.85rem;
      color: #6b7280;
    }
  }

  .course-tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin: 16px 0;
    
    .tag {
      background: rgba(99, 102, 241, 0.1);
      color: #6366f1;
      padding: 4px 10px;
      border-radius: 12px;
      font-size: 0.75rem;
      font-weight: 500;
    }
  }

  .course-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0 16px 0;
    padding-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    
    .instructor {
      font-size: 0.85rem;
      color: #6b7280;
    }
    
    .price {
      font-size: 1.2rem;
      font-weight: bold;
      color: #f59e0b;
    }
  }

  .learn-btn {
    width: 100%;
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 12px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(99, 102, 241, 0.4);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
`;

export default OnlineCourseList;